import React, { useCallback, useEffect, useState } from 'react'
import {
    Button, Image, Toast, Tag
} from 'antd-mobile'
import { ClockCircleOutline } from 'antd-mobile-icons'
import Icon from '../../icon';
import { useNavigate } from 'react-router-dom';
import './index.css'
import { useAuth } from '../../app/providers/AuthProvider';
import { matchApi } from '../../features/match/api/matchApi';
import { teamApi } from '../../features/team/api/teamApi';

const GameYearGameList = ({ gameYearId, canCreate = true }) => {

    const [gameYearGameList, setGameYearGameList] = useState([]);
    const [teamCount, setTeamCount] = useState(0);

    const { memberInfo } = useAuth();

    const navigate = useNavigate();

    const getYearGameInfo = useCallback(() => {
        matchApi.getList({
            count: 10,
            current: 1,
            size: 10,
            status: '0,1,2,3,4',
            gameId: gameYearId
        })
            .then(function (response) {
                const resultData = response.data.data.records
                setGameYearGameList(resultData)
                Toast.clear()
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员！'
                })
            })
    }, [gameYearId])

    useEffect(() => {
        getYearGameInfo()
    }, [getYearGameInfo])

    useEffect(() => {
        // 活动至少有两队才能建赛；不足时直接引导管理员先建队。
        teamApi.getList(gameYearId).then(response => setTeamCount(response.data.data?.length || 0))
            .catch(() => setTeamCount(0));
    }, [gameYearId])

    const getTeamLogo = (team, gameDetail) => {
        // 科朋队伍只展示队徽；外战队伍无队徽时交由圆形名称占位展示。
        const logo = gameDetail?.[`${team}TeamLogo`];
        if (logo) return logo + Icon.ImageFooter;
        return Number(gameDetail?.[`${team}TeamType`]) === 1 ? '' : Icon.KEPENG_LOGO;
    }

    const renderTeamBadge = (team, gameDetail) => {
        const logo = getTeamLogo(team, gameDetail);
        const name = gameDetail?.[`${team}Name`] || '队伍';
        const color = gameDetail?.[`${team}Color`] || (team === 'green' ? '#00B42A' : '#F53F3F');
        return logo ? <Image src={logo} className="team-avatar-match" width={50} height={50} fit="cover" style={{ border: `2px solid ${color}` }} />
            : <div className="team-avatar-match team-avatar-name" title={name} aria-label={`${name}队徽占位`} style={{ border: `2px solid ${color}` }}>{name.length > 4 ? name.slice(0, 4) : name}</div>;
    }

    const getHalfScore = (gameDetail) => {
        const calculateHalf = (teamNum) => gameDetail?.gameEventInfoVOList?.filter(item =>
            ((["11", "12", "13", "14", "15", "16", "3"].includes(item.eventId) && item.gameTeam === teamNum) ||
                (item.eventId === "4" && item.gameTeam === (teamNum === 1 ? 2 : 1))) &&
            new Date(item.currentTime) <= new Date(gameDetail?.endTime) &&
            (!gameDetail?.secondHalfStartTime || new Date(item.currentTime) < new Date(gameDetail?.secondHalfStartTime))
        ).length || 0;

        return `${calculateHalf(1)} : ${calculateHalf(2)}`;
    }

    return (

        <div style={{ padding: '0' }}>
            {memberInfo?.admin === 1 && canCreate &&
                <Button 
                    className="create-match-btn-fixed"
                    color='primary' 
                    block
                    onClick={() => navigate(teamCount < 2 ? '/createTeam' : '/createGamePk', { state: teamCount < 2 ? { yearId: gameYearId } : { gameYearId } })}>
                    {teamCount < 2 ? '＋ 先创建队伍' : '＋ 创建比赛'}
                </Button>
            }
            
            {gameYearGameList?.length === 0 && <div className="year-match-empty">{teamCount < 2 ? '先创建至少两支队伍，再安排对阵。' : '暂无比赛，可安排第一场对阵。'}</div>}
            {gameYearGameList && gameYearGameList.map((gameDetail) => (
                <div 
                    key={gameDetail.id}
                    className="match-card-item"
                    onClick={() => {
                        const stages = { 0: 'signup', 1: 'ready', 2: 'live', 3: 'history' };
                        const stage = stages[gameDetail.status];
                        if (stage) navigate(`/games/${gameDetail.id}/${stage}`, { state: { gameYearId } });
                    }}
                >
                    <div className="match-header">
                        <div className="match-title-box">
                            <span className="match-name-text">{gameDetail.gameName}</span>
                            <div className="match-time-text">
                                <ClockCircleOutline />
                                <span>{gameDetail.startDate} {gameDetail.startTime}</span>
                            </div>
                        </div>
                        <div className="match-status-box">
                            {gameDetail?.status === 0 ? <Tag round color='#f53f3f' className="match-status-tag">待开赛</Tag> :
                             gameDetail?.status === 1 ? <Tag round color='#ff7d00' className="match-status-tag">分队中</Tag> :
                             gameDetail?.status === 2 ? <Tag round color='#165dff' className="match-status-tag">比赛中</Tag> :
                             gameDetail?.status === 3 ? <Tag round color='#86909c' className="match-status-tag">已结束</Tag> :
                             gameDetail?.status === 4 ? <Tag round fill='outline' className="match-status-tag">已取消</Tag> : null
                            }
                        </div>
                    </div>

                    <div className="match-vs-container">
                        <div className="team-display-box">
                            {renderTeamBadge('green', gameDetail)}
                            <div className="team-name-match">{gameDetail?.greenName}</div>
                        </div>

                        <div className="score-display-box">
                            <div className="main-score-text">
                                {gameDetail?.greenGoal} : {gameDetail?.redGoal}
                            </div>
                            {Number(gameDetail?.gameCourse) > 1 && gameDetail?.status === 3 && <div className="half-time-score">
                                半场 {getHalfScore(gameDetail)}
                            </div>}
                        </div>

                        <div className="team-display-box">
                            {renderTeamBadge('red', gameDetail)}
                            <div className="team-name-match">{gameDetail?.redName}</div>
                        </div>
                    </div>

                </div>
            ))}
        </div>
    )
}

export default GameYearGameList;
